// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-error-infinite-loop').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-error-infinite-loop/build.source.js
// module id = 279
// module chunks = 9